import React from 'react'
import Topbar from '../Components/Topbar';
import Navbar from '../Components/Navbar';
import { CartProvider, useCart } from 'react-use-cart';
function Cart() {
    const {isEmpty,totalUniqueItems,items,updateItemQuantity,removeItem,cartTotal} =
     useCart();
    if (isEmpty) {
  
      return (
        <h2 className='text-center'>Your cart is empty</h2>
      )
    }
  
    return (
      <div>
         <section class="h-100 gradient-custom">
  <div class="container py-5">
    <div class="row d-flex justify-content-center my-4">
      <div class="col-md-8">
        <div class="card mb-4">
          <div class="card-header py-3">
            <h5 class="mb-0">Cart - ({totalUniqueItems}) items</h5>
          </div>
          <div class="card-body">
            {/* <!-- Single item --> */}
            {items.map( (item)=>(

            <div class="row">
              <div class="col-lg-3 col-md-12 mb-4 mb-lg-0">
                {/* <!-- Image --> */}
                <div class="bg-image hover-overlay hover-zoom ripple rounded" data-mdb-ripple-color="light">
                  <img src={item.images[0]}
                    class="w-100"/>
                  <a href="#!">
                    <div class="mask" style={{backgroundColor: "rgba(251, 251, 251, 0.2)"}}></div>
                  </a>
                </div>
                {/* <!-- Image --> */}
              </div>

              <div class="col-lg-5 col-md-6 mb-4 mb-lg-0">
                {/* <!-- Data --> */}
                <p><strong>{item.title}</strong></p>
                <p><strong className='text-danger'>ID:</strong><span className='mx-1'></span>{item.id}</p>
                <p><strong className='text-danger'>Price:</strong><span className='mx-1'></span>{Math.ceil(item.price)}</p>
                <button  type="button" data-mdb-button-init data-mdb-ripple-init class="btn btn-primary btn-sm me-1 mb-2" data-mdb-tooltip-init
                  title="Remove item" onClick={()=>removeItem(item.id)}>
                  <i class="fas fa-trash"></i>
                </button>
                <button  type="button" data-mdb-button-init data-mdb-ripple-init class="btn btn-danger btn-sm mb-2" data-mdb-tooltip-init
                  title="Move to the wish list">
                  <i class="fas fa-heart"></i>
                </button>
                {/* <!-- Data --> */}
              </div>

              <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                {/* <!-- Quantity --> */}
                <div class="d-flex mb-4" style={{maxWidth: "300px"}}>
                  <button className='btn btn-success' onClick={()=>updateItemQuantity(item.id,item.quantity-1)}>-</button>
                   <div class="col-md-4 quantity text-center">
                    <label for="quantity">Quantity:</label>
                    <br/>
                    {item.quantity}
                    </div>
                  <button className='btn btn-dark mx-3' onClick={()=>updateItemQuantity(item.id,item.quantity+1)}>+</button>
                  <button onClick={()=>removeItem(item.id)} className='btn btn-danger'>&times;</button>
                </div>
                {/* <!-- Quantity --> */}

                {/* <!-- Price --> */}
                <p class="text-start text-md-center">
                  <strong>{Math.ceil(item.price*item.quantity)}$</strong>
                </p>
                {/* <!-- Price --> */}
              </div>
              <hr class="my-4" />
            </div>
            ))}
            {/* <!-- Single item --> */}


            
          </div>
        </div>
        <div class="card mb-4">
          <div class="card-body">
            <p><strong>Expected shipping delivery</strong></p>
            <p class="mb-0">12.10.2020 - 14.10.2020</p>
          </div>
        </div>
        <div class="card mb-4 mb-lg-0">
          <div class="card-body">
            <p><strong>We accept</strong></p>
            <img class="me-2" style={{width:"45px"}}
              src="https://mdbcdn.b-cdn.net/wp-content/plugins/woocommerce-gateway-stripe/assets/images/visa.svg"
              alt="Visa" />
            <img class="me-2" style={{width:"45px"}}
              src="https://mdbcdn.b-cdn.net/wp-content/plugins/woocommerce-gateway-stripe/assets/images/amex.svg"
              alt="American Express" />
            <img class="me-2" style={{width:"45px"}}
              src="https://mdbcdn.b-cdn.net/wp-content/plugins/woocommerce-gateway-stripe/assets/images/mastercard.svg"
              alt="Mastercard" />
              </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card mb-4">
          <div class="card-header py-3">
            <h5 class="mb-0">Summary</h5>
          </div>
          <div class="card-body">
            <ul class="list-group list-group-flush">
              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                Products
                <span>{Math.ceil(cartTotal)}$</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center px-0">
                Shipping
                <span>Gratis</span>
              </li>
              <li
                class="list-group-item d-flex justify-content-between align-items-center border-0 px-0 mb-3">
                <div>
                  <strong>Total amount</strong>
                  <strong>
                    <p class="mb-0">(including VAT)</p>
                  </strong>
                </div>
                <span><strong>{Math.ceil(cartTotal+30)}$</strong></span>
              </li>
            </ul>

            <button  type="button" data-mdb-button-init data-mdb-ripple-init class="btn btn-danger btn-lg btn-block m-auto">
            Checkout
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
      </div>
    );
  }

function AllCart() {
  return (
    <CartProvider>
        <Topbar/>
        <Navbar/>
        <Cart/>
    </CartProvider>
  )
}

export default AllCart